import type { PointShortTypeFragment } from '@shared/api/graphql/generated';

import type { ReportAddressTagType, ReportAddressType } from './types';

export const mapPointToReportAddress = (point: PointShortTypeFragment): ReportAddressType => ({
  id: point.id,
  address: point.address,
  comment: point.comment,
  tags: point.tags?.map(({ id, title }) => ({ id, title })) || [],
});

export const getReportAddressTags = (addresses: ReportAddressType[]): ReportAddressTagType[] => {
  const tagMap = addresses.reduce<Map<string, ReportAddressTagType>>((acc, address) => {
    address.tags.forEach((tag) => {
      if (!acc.has(tag.id)) {
        acc.set(tag.id, tag);
      }
    });

    return acc;
  }, new Map());

  return Array.from(tagMap.values());
};
